<div class="d-flex flex-row justify-content-between">
	<h1>
		<span *ngIf="auditName">
			{{ auditName }}
		</span>
	</h1>
	<div id="pageActions">
		<button ngbTooltip="Export to Excel" (click)="table.getExcel()" class="page-action export-to-excel"></button>
	</div>
</div>

<pcg-table #table [ajaxData]="filters" [pcgSort]="[['dateChanged', 'desc']]" dataSource="api/AuditHistory/GetAuditHistory"
	[columnDefs]="columns" (tableReceive)="auditName = $event.value" [canExactMatchSearch]="false">
    
	<ng-container cdkColumnDef="dateChanged">
		<th cdk-header-cell pcg-sort-header *cdkHeaderCellDef>{{ columns.get('dateChanged').displayName }}</th>
		<td cdk-cell *cdkCellDef="let row" data-label="Date Changed">{{ row.dateChangedFormatted }}</td>
	</ng-container>

	<ng-container cdkColumnDef="field">
		<th cdk-header-cell pcg-sort-header *cdkHeaderCellDef>{{ columns.get('field').displayName }}</th>
		<td cdk-cell *cdkCellDef="let row" data-label="Field">{{ row.field }}</td>
	</ng-container>

	<ng-container cdkColumnDef="changedFrom">
		<th cdk-header-cell pcg-sort-header *cdkHeaderCellDef>{{ columns.get('changedFrom').displayName }}</th>
		<td cdk-cell *cdkCellDef="let row" data-label="Changed From">{{ row.changedFrom }}</td>
	</ng-container>

	<ng-container cdkColumnDef="changedTo">
		<th cdk-header-cell pcg-sort-header *cdkHeaderCellDef>{{ columns.get('changedTo').displayName }}</th>
		<td cdk-cell *cdkCellDef="let row" data-label="Changed To">{{ row.changedTo }}</td>
	</ng-container>

	<ng-container cdkColumnDef="changedBy">
		<th cdk-header-cell pcg-sort-header *cdkHeaderCellDef>{{ columns.get('changedBy').displayName }}</th>
		<td cdk-cell *cdkCellDef="let row" data-label="Changed By">{{ row.changedBy }}</td>
	</ng-container>
</pcg-table>
